import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';
import type { PaymentCategory } from '../interfaces/payment';

@Injectable({
  providedIn: 'root'
})
export class PaymentCategoryService extends CrudService<PaymentCategory> {

  constructor() {
    super('payment-categories');
  }
}
